module.exports = __webpack_public_path__ + "static/media/pending.f305b2a0.svg";